// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"485":"8685b743","595":"ab2d0744"}[chunkId] + ".chunk.js";
};